import axios from 'axios';

export async function getLogs(page: number, limit: number) {
  const res = await axios.get<Models.Paginated<Models.Log>>('eventlog/list', {
    params: { limit, offset: limit * (page - 1) },
  });
  return res.data;
}